import React from 'react';
import { useTheme, styled } from '@mui/material/styles';
import { useMediaQuery, Paper, Typography, Box, Chip } from '@mui/material';
// import { convertDate, timeSince } from '../../../../../helpers/time';
// import Link from 'next/link';
// import LowPriorityRoundedIcon from '@mui/icons-material/LowPriorityRounded';
// import CircleNotificationsRoundedIcon from '@mui/icons-material/CircleNotificationsRounded';
// import SwipeDownAltIcon from '@mui/icons-material/SwipeDownAlt';
// import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
// import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded';
// import SubdirectoryArrowRightRoundedIcon from '@mui/icons-material/SubdirectoryArrowRightRounded';
// import LowPriorityRoundedIcon from '@mui/icons-material/LowPriorityRounded';
// import MoveDownRoundedIcon from '@mui/icons-material/MoveDownRounded';
import { parseTabData } from '../../../../../utils/helpers';
import TrendingDownRoundedIcon from '@mui/icons-material/TrendingDownRounded';
import MovingRoundedIcon from '@mui/icons-material/MovingRounded';
import KeyboardDoubleArrowDownRoundedIcon from '@mui/icons-material/KeyboardDoubleArrowDownRounded';
import KeyboardDoubleArrowUpRoundedIcon from '@mui/icons-material/KeyboardDoubleArrowUpRounded';
import RemoveCircleOutlineRoundedIcon from '@mui/icons-material/RemoveCircleOutlineRounded';
import Diversity3RoundedIcon from '@mui/icons-material/Diversity3Rounded';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    // color: theme.palette.primary.main,
    color: "#293f5a",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    // backgroundColor: theme.palette.primary.main,
    backgroundColor: "#2a2d64",
    fontWeight: 600,
    color: '#fff',
    boxShadow: theme.shadows?.[3],
    fontSize: 12,
    padding: '7px 15px 7px 15px',
  },
}));

const ListItem = styled('li')(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

const AlertItem = styled(Paper)(({ theme }) => ({
  // boxShadow: '0 0.5px 1px rgb(132 135 154 / 20%), 0 2px 3px rgb(132 135 154 / 10%) !important',
  // boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(132 135 154 / 20%), 0 2px 3px rgb(132 135 154 / 10%)',
  boxShadow: theme.palette?.mode === 'dark' ? 0 : '0 0.5px 1px rgb(255 255 255 / 20%), 0 2px 3px rgb(255 255 255 / 10%)',
  // border: theme.palette.mode === 'dark' ? '1px solid rgb(19, 47, 76)' : '1px solid #eae9ee',
  borderRadius: '7px',
}));

const alertDescriptions = {
  "REVDEC": {
    "shortDesc": "Revenue Decline",
    "longDesc": "Indicates a decrease in company revenue, influencing stock performance.",
    "icon": <TrendingDownRoundedIcon />
  },
  "REVINC": {
    "shortDesc": "Revenue Increase",
    "longDesc": "Highlights a rise in company revenue, positively impacting financial standing.",
    "icon": <MovingRoundedIcon />
  },
  "EARNDEC": {
    "shortDesc": "Earnings Decline",
    "longDesc": "Signals a decrease in company earnings, affecting profitability.",
    "icon": <KeyboardDoubleArrowDownRoundedIcon />
  },
  "EARNINC": {
    "shortDesc": "Earnings Increase",
    "longDesc": "Points to a rise in company earnings, contributing to financial growth.",
    "icon": <KeyboardDoubleArrowUpRoundedIcon />
  },
  "NEGINC": {
    "shortDesc": "Negative Income",
    "longDesc": "Flags negative change in income, warranting attention for financial downturn.",
    "icon": <RemoveCircleOutlineRoundedIcon />
  },
  "INS": {
    "shortDesc": "Insider Trading",
    "longDesc": "Indicates significant insider trading activity within the company.",
    "icon": <Diversity3RoundedIcon />
  },
  "13G": {
    "shortDesc": "Form 13G Filing",
    "longDesc": "Signifies a filed SEC Form 13G, reflecting ownership changes in the company.",
    "icon": <DescriptionRoundedIcon />
  }
};

const StockAlerts = ({ stockAlerts, tabData, info }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  // const _is = useMediaQuery('(min-width:600px)', { noSsr: true });
  // const matches = useMediaQuery('(min-width:600px)', { noSsr: true });
  // const matches = useMediaQuery('(min-width:600px)', { noSsr: true });

  let alertSettings = tabData && tabData.length > 0 ? tabData.find(d => d.section_code === "alerts") : null;
  alertSettings = alertSettings ? parseTabData(alertSettings) : null

  let alertConfig = alertSettings && alertSettings.settings && alertSettings.settings?.alertConfig ? alertSettings.settings?.alertConfig : null;
  alertConfig = alertConfig && alertConfig?.length > 0 ? alertConfig?.map(alert => ({
    alert_type: alert.alertType,
    color: alert.color,
    shortDesc: alertDescriptions[alert.alertType].shortDesc,
    longDesc: alertDescriptions[alert.alertType].longDesc,
    link: alert.link,
    icon: alertDescriptions[alert.alertType].icon
  })) : null;

  return (
    <>
      {stockAlerts && stockAlerts.length > 0 &&
        // <Grid size={{ md: 12, xs: 12 }} sx={{ maxWidth: '100%', position: isDesktop ? 'absolute' : '', zIndex: 2, top: '-6.5rem', right: 0 }}>
        <AlertItem elevation={0} style={{ borderRadius: '7px', }}>
          <Box className="Alert-Head"
            sx={{
              background: '#B30000',
              padding: '4px 8px 4px 8px !important',
              borderRadius: '7px 7px 0 0 !important',
              '& a': {
                textDecoration: 'none',
              },
            }}>
            <Typography component="h4" className="option-title"
              sx={{
                mr: 'auto',
                '&.option-title': {
                  fontWeight: 600,
                  color: "#fff !important",
                  // color: 'rgb(102, 60, ÷0)',
                  fontSize: '.8rem',
                }
              }} >
              {info?.ticker} Alerts
            </Typography>
          </Box>
          <Paper variant="outlined" elevation={0} style={{ borderColor: '#eae9ee', borderTop: 0 }}
            sx={{
              // maxWidth: { md: '35.6rem', sm: '100%' },
              maxHeight: '4.5rem', overflow: 'auto', display: 'flex', flexWrap: 'wrap', listStyle: 'none', p: 0.5, m: 0,
              borderRadius: '0 0 7px 7px', boxShadow: 0,
              '&::-webkit-scrollbar-thumb': {
                background: '#020e4a29',
                borderRadius: '1px 1px 7px 1px '
              },
              '&:hover::-webkit-scrollbar-thumb': {
                background: '#020e4a85',
                borderRadius: '1px 1px 7px 1px '
              },
              '&::-webkit-scrollbar-track': {
                background: '#f2f2f2',
                borderRadius: '1px 1px 7px 1px '
              },
              '&::-webkit-scrollbar': {
                width: '5px !important',
                height: '5px !important'
              }
            }}
            component="ul"
          >
            {stockAlerts.map((c, i) => {
              const alert = alertConfig && alertConfig.length > 0 ? alertConfig.find(d => d.alert_type === c.alert_type) : null
              const alertID = alert && alert?.link ? (alert?.link).replace(/[^a-zA-Z0-9]/g, '') : "#"
              return (c.alert &&
                <LightTooltip describeChild title={alert?.longDesc ?? ""} arrow placement="top" disableInteractive>
                  <ListItem key={`alert-${i}`}>
                    <Chip
                      // onClick={(e) => elementID === "#" ? e.preventDefault() : document.getElementById(elementID).scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })}
                      href={alert?.link}
                      component="a"
                      size="small"
                      label={c.alert}
                      // icon={alertID === '#' ?
                      //   <FiberManualRecordIcon sx={{ color: alert && alert.color ? `${alert.color} !important` : 'inherit', fontSize: '.5rem !important' }} /> :
                      //   <MoveDownRoundedIcon sx={{ color: alert && alert.color ? `${alert.color} !important` : 'inherit', fontSize: '1.2rem !important' }} />}
                      sx={{
                        cursor: 'pointer',
                        color: alert && alert.color ? alert.color : 'inherit',
                        bgcolor: alert && alert.color ? `${alert.color}12` : 'inherit',
                        '&:hover': { bgcolor: alert && alert.color ? `${alert.color}1e` : 'inherit', },
                        fontSize: '.8rem'
                      }}
                    />
                    {/*  <Button
                        sx={{ py: 0.2, px: 1, '& .SwipeDownAlt': { display: 'none' }, '&:hover .SwipeDownAlt': { display: 'inline-block' }, '&:hover .ManualRecord': { display: 'none' }, '&:hover': { bgcolor: 'rgb(255 244 246)' } }}
                        startIcon={[<ArrowDownwardRoundedIcon className="SwipeDownAlt" sx={{ fontSize: '.9rem !important', color: config?.color, }} />, <FiberManualRecordIcon className="ManualRecord" sx={{ fontSize: '.5rem !important', color: config?.color, ml: .2, mr: .6 }} />]}
                        onClick={(e) => elementID === "#" ? e.preventDefault() : document.getElementById(elementID).scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })}
                      >
                        <Typography variant="caption" display="block"
                          sx={{
                            textAlign: 'left', textTransform: 'capitalize',
                            fontSize: '.8rem', whiteSpace: 'nowrap', textOverflow: 'ellipsis', display: 'block', overflow: 'hidden',
                            color: config && config.color ? config.color : 'inherit'
                          }}>
                          {alert.alert}
                        </Typography>
                      </Button> */}
                  </ListItem>
                </LightTooltip>)
            })}
          </Paper>
        </AlertItem>
        // </Grid >
      }
    </>
  );
}

export default React.memo(StockAlerts);
